import { api, ReactQueryOptions, RouterInputs } from '@api'
import { staleTimeIndex } from '@specs/constants'

type optionsType = ReactQueryOptions['SocialManager']['countFollowing']
type inputType = RouterInputs['SocialManager']['countFollowing']

export const useCountFollowing = (input: inputType, options?: optionsType) =>
    api.SocialManager.countFollowing.useQuery(input, {
        ...options,
        queryKey: ['SocialManager.countFollowing', input],
        staleTime: 60 * 60 * 1000 * staleTimeIndex, // 1 hour
    })
